<template>
  <div id="box">
    <HeaderView />
    <div class="banner">
      <div
        class="carousel"
        @mouseenter="pauseAutoPlay"
        @mouseleave="startAutoPlay"
      >
        <div
          class="carousel-inner"
          :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
        >
          <div class="slide" v-for="(item, i) in banners" :key="i">
            <img :src="item.img" alt="" />
            <div class="banner-title" v-html="item.title"></div>
            <!-- <div class="banner-btn">
              <span class="btn-icon"></span>
              <span>了解更多</span>
            </div> -->
          </div>
        </div>
        <div class="dots">
          <span
            v-for="(img, i) in banners"
            :key="i"
            :class="{ active: i === currentIndex }"
            @click="goTo(i)"
          ></span>
        </div>
      </div>
    </div>

    <section class="section1">
      <div class="container">
        <div class="section-title">
          <h4>产品介绍</h4>
          <p class="section-description">
            畜牧业（鸡、鸭、鹅、牛、羊）钢结房病舍、渔业钢结房病舍、温室大棚钢结房病舍，设计及钢结构配套服务。
          </p>
        </div>
        <div class="products-grid">
          <div
            class="product-card wow fadeInLeft"
            v-for="(item, index) in products"
            :key="item.id"
            :class="{ 'product-card-full': index === 2 }"
          >
            <div class="product-image">
              <img :src="item.image" :alt="item.name" />
            </div>
            <div class="product-content">
              <h5 class="product-title">{{ item.name }}</h5>
              <p class="product-description">{{ item.description }}</p>
              <router-link :to="`/product?id=${item.id}`" class="product-link">了解更多</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section2">
      <div class="container">
        <div class="section-title">
          <h4>合作伙伴</h4>
        </div>
        <div class="s2-content">
          <MapView />

          <div class="service-container wow fadeInRight">
            <div class="service-card" v-for="item in partnerList" :key="item.id">
              <img
                :src="item.image"
                :alt="item.title"
                class="card-img"
              />
              <div class="card-content">
                <h3 class="card-title">{{ item.title }}</h3>
                <p class="card-desc">{{ item.brief }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="container">
        <div class="section-title">
          <h4>新闻动态</h4>
        </div>
        <div class="news-box">
          <div
            class="news-item"
            v-if="newsList[0]"
            @click="$router.push(`/newsdetail/${newsList[0].id}`)"
          >
            <div class="news-date">{{ newsList[0].create_time }}</div>
            <div class="news-title">{{ newsList[0].titile }}</div>
            <div class="news-desc">{{ newsList[0].brief }}</div>
            <span class="news-link">了解更多&gt;</span>
            <img :src="newsList[0].b_image" alt="" class="news-img" />
          </div>

          <div class="news-item2" v-if="newsList.length>1">
            <div
              class="news-s"
              v-if="newsList[1]"
              @click="$router.push(`/newsdetail/${newsList[1].id}`)"
            >
              <div class="news-date">{{ newsList[1].create_time }}</div>
              <div class="news-title">{{ newsList[1].titile }}</div>
              <div class="news-desc2">{{ newsList[1].brief }}</div>
              <span class="news-link2">了解更多&gt;</span>
            </div>
            <div
              class="news-s"
              v-if="newsList[2]"
              @click="$router.push(`/newsdetail/${newsList[2].id}`)"
            >
              <div class="news-date">{{ newsList[2].create_time }}</div>
              <div class="news-title">{{ newsList[2].titile }}</div>
              <div class="news-desc2">{{ newsList[2].brief }}</div>
              <span class="news-link2">了解更多&gt;</span>
            </div>
          </div>
          <div
            class="news-item3"
            v-if="newsList[3]"
            @click="$router.push(`/newsdetail/${newsList[3].id}`)"
          >
            <div class="news3-text">
              <div class="news-date3">{{ newsList[3].create_time }}</div>
              <div class="news-title3">{{ newsList[3].titile }}</div>
              <div class="news-desc3">{{ newsList[3].brief }}</div>
              <span class="news-link3">了解更多&gt;</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section4">
      <div class="container">
        <div class="about-company">
          <div class="company-image">
            <img :src="moreData.about_image" alt="企业建筑" class="building-img">
          </div>
          <div class="company-content">
            <h3 class="company-title">走进企业</h3>
            <div class="company-text" v-html="moreData.about_content">
            </div>
            <!-- <div class="company-text">
              <p class="company-paragraph">
                山东新牧智能装备有限公司，位于中国山东青岛，主营禽舍、猪舍、温室大棚、谷仓等轻型钢结构的设计、研发、销售、安装及技术服务。
              </p>
              <p class="company-paragraph">
                公司配置全套的钢构、维护系统生产线，拥有先进的等离子数控切割生产线、埋弧焊生产线、各种类型剪板机、折弯机以及C/Z型数控檩条生产线等设备。
              </p>
              <p class="company-paragraph">
                设备先进、技术雄厚、检测齐全，更有一支设计、生产、配送、安装、售后的优秀团队，是一家生产、销售一体的多元化企业。
              </p>
            </div> -->
            <div class="company-metrics" ref="metricsBox">
              <div class="metric-item">
                <div class="metric-value">{{ formatNumber(area) }} <span class="metric-unit">m²</span></div>
                <div class="metric-label">占地面积</div>
              </div>
              <div class="metric-item">
                <div class="metric-value">{{ formatNumber(investment) }} <span class="metric-unit">元</span></div>
                <div class="metric-label">总投资额</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <FooterView />
  </div>
</template>

<script>
import apiServe from "@/services/index.js";
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
import MapView from "@/components/3DmapView.vue";
import WOW from "wow.js";
import "animate.css";
export default {
  components: {
    HeaderView,
    FooterView,
    MapView,
  },
  data() {
    return {
      banners: [],
      currentIndex: 0,
      timer: null,
      // 数字动画相关
      area: 0,          // 占地面积实时值
      investment: 0,    // 总投资额实时值
      areaTarget: 1,
      investmentTarget: 5,
      metricObserver: null,
      metricAnimated: false,
      products: [],   // 产品列表
      partnerList: [], // 合作伙伴列表
      newsList: [],    // 新闻列表
      moreData: {},    // 更多数据
    };
  },
  created() {},
  mounted() {
    this.getMoreData();
    this.getIndexData();
    this.initWOW();
    this.initScrollAnimation();
    this.initMetricAnimation();
  },
  beforeDestroy() {
    this.pauseAutoPlay();
    if (this.metricObserver) {
      this.metricObserver.disconnect();
      this.metricObserver = null;
    }
  },
  methods: {
    getMoreData() {
      apiServe.getMoreData().then((res) => {
          this.moreData = res.data;
          // 对接接口数据，保留默认值兜底
          this.areaTarget = res.data.about_mj;
          this.investmentTarget = res.data.about_tz;
      })
    },
    getIndexData() {
      apiServe.getIndexData().then(res => {
        if (res.data && res.data.banner) {
          this.banners = res.data.banner.map(item => ({
            title: item.title,
            img: item.image
          }));
          // 数据加载完成后延迟启动轮播，确保图片加载完成
          this.$nextTick(() => {
            this.startAutoPlay();
          });
        }
        if (res.data && res.data.product) {
          this.products = res.data.product;
        }
        if (res.data && res.data.partner) {
          this.partnerList = res.data.partner;
        }
        if (res.data && res.data.news) {
          this.newsList = res.data.news;
        }
      }).catch(err => {
        console.error('获取首页数据失败:', err);
        // 如果接口失败，使用默认数据
        this.banners = [
          {
            title: "成为技术突出的世界级工程服务企业",
            img: "/imgs/home/images/home-banner_01.png",
          }
        ];
        this.startAutoPlay();
      })
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.banners.length;
      }, 4000);
    },
    pauseAutoPlay() {
      clearInterval(this.timer);
      this.timer = null;
    },
    goTo(index) {
      this.currentIndex = index;
    },
    initScrollAnimation() {
      // 定义需要动画的元素
      const animateEls = [
        '.section3',
        '.section4',
        '.news-box',

      ];
      // 给元素添加 animate 类并设置初始透明
      animateEls.forEach(selector => {
        const el = document.querySelector(selector);
        if (el) {
          el.classList.add('animate');
        }
      });
      // 同步检测首屏元素
      this.checkAnimated();
      // 使用 IntersectionObserver 监听进入视口
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      document.querySelectorAll('.animate').forEach(el => observer.observe(el));
    },
    checkAnimated() {
      // 首屏元素立即触发，避免闪烁
      document.querySelectorAll('.animate').forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('animated');
        }
      });
    },
    // 初始化 WOW.js 动画
    initWOW() {
      new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      }).init();
    },
    // 数字格式化（千分位）
    formatNumber(num) {
      return num.toLocaleString('zh-CN');
    },
    // 数字增长动画
    animateNumber(start, end, duration, callback) {
      const startTime = performance.now();
      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.floor(start + (end - start) * progress);
        callback(current);
        if (progress < 1) {
          requestAnimationFrame(update);
        }
      };
      requestAnimationFrame(update);
    },
    // 监听公司指标进入视口
    initMetricAnimation() {
      const metricsBox = this.$refs.metricsBox;
      if (!metricsBox) return;
      this.metricObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.metricAnimated) {
            this.metricAnimated = true;
            // 启动占地面积动画
            this.animateNumber(0, this.areaTarget, 1500, (val) => {
              this.area = val;
            });
            // 启动总投资额动画
            this.animateNumber(0, this.investmentTarget, 1800, (val) => {
              this.investment = val;
            });
            // 动画完成后停止监听
            this.metricObserver.disconnect();
            this.metricObserver = null;
          }
        });
      }, { threshold: 0.5 });
      this.metricObserver.observe(metricsBox);
    },

  },

  metaInfo() {
    return {
      title: this.moreData.title,
      meta: [
        { name: 'keywords', content: this.moreData.keywords},
        { name: 'description', content: this.moreData.description}
      ]
    };
  }
};
</script>
<style src="@/assets/animate.css">
  
</style>
<style scoped>

.container{
    width: clamp(90%, 100%, 1600px);
    margin: 0 auto;
    padding: 0 2vw;
    box-sizing: border-box;
    position: relative;
}
/* 进入视口动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(90px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate {
  opacity: 0;
}
.animated {
  animation: fadeInUp 1.5s ease forwards;
}
section {
  width: 100%;
  padding: 5rem 0;
}
.section-title {
  text-align: left;
  margin-bottom: 4rem;
}
/* -------------------section2----------------------------------- */
.section2 {
  background: #edf0f7;
}
.s2-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.service-container {
  max-width: 600px;
  height: 720px;
  overflow-y: auto;
  margin: 0 auto;
  padding: 0 50px;
  position: relative;
}

/* 自定义滚动条样式 */
.service-container::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
}

.service-container::-webkit-scrollbar-track {
  background: #c5c5c6; /* 轨道灰色 */
  border-radius: 3px;
}

.service-container::-webkit-scrollbar-thumb {
  background: #ff8a00; /* 滑块蓝色 */
  border-radius: 3px; /* 进度条形状 */
}
.service-card {
  background: #fff;
  border-radius: 25px;
  box-shadow: 17px 20px 33px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 20px;
  gap: 2rem;
}
.card-img {
  width: 175px;
  height: 180px;
  border-radius: 15%;
  object-fit: cover;
}
.card-content {
  flex: 1;
  padding: 0 35px;
}
.card-title {
  font-size: 35px;
  /*font-weight: 600; */
  margin-bottom: 8px;
}
.card-desc {
  font-family: "Source_Han_Sans_SC_Normal";

  font-size: 20px;
  color: #666;
  margin-bottom: 12px;
}
.card-btn {
  font-size: 14px;
  color: #ff8a00;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.card-btn::after {
  content: "→";
  font-size: 12px;
}
/* ---------------section3----------------------- */
.section3 {
  background-image: url("/public/imgs/home/images/new-bg_02.png");
  background-size: cover;
  background-position: center;
}

.news-box {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  gap: 1.5rem;
}
.news-item {
  /* 三个值依次代表：flex-grow=1（剩余空间可放大）、flex-shrink=1（空间不足可缩小）、flex-basis=30%（初始主轴尺寸占父容器30%） */
  flex: 1 1 30%;
  max-width: 425px;
  /* 表示元素宽高比固定为 0.6（宽 : 高 = 0.6 : 1） */
  aspect-ratio: 0.6;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.news-item2 {
  flex: 1 1 38%;
  max-width: 505px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.5rem;
}

.news-s {
  flex: 1 1 45%;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.news-item3 {
  background-image: url("/public/imgs/home/images/news-img2_03.png");
  background-size: cover;
  background-position: center;
  flex: 1 1 30%;
  max-width: 425px;
  aspect-ratio: 0.6;
  background-color: #fff;
  border-radius: 15px;
  padding: 30px 50px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.news-item3::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom,  transparent 50%,#ff8a00 100%);
  pointer-events: none;
  z-index: 1;
}
.news-item,.news-s,.news-item3 {
  transition: transform 0.3s ease-in-out;
}
.news-item:hover,.news-s:hover,.news-item3:hover {
  transform: translateY(-10px);
 
}
.news-item:hover .news-link {
    color: #ff8a00;
}
.news-s:hover .news-link2 {
    color: #ff8a00;
}
/* .news-item3:hover .news-link3 {
    color: #ff8a00;
} */
.news3-text {
  margin-top: 90%;
  color: #fff;
  position: relative;
  z-index: 2;
   /* position: absolute;
   top: 65%;
   left: 0%;
   transform: translate(-50%, -50%); */
}
.news-date {
  color: #ff8a00;
  font-size: 14px;
  margin-bottom: 10px;
}
.news-title {
  font-size: 23px;
   /* font-weight: bold; */
  margin-bottom: 10px;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.news-desc {
  font-size: 19px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  flex: 1;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.news-desc2 {
  font-size: 19px;
  color: #666;
  line-height: 1.6;
   /* margin-bottom: 20px; */
  flex: 1;
  min-height: 150px;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-link {
  color: #333;
  font-size: 16px;
  text-decoration: none;
  margin-bottom: 60px;
}
.news-link2 {
  color: #333;
  font-size: 16px;
  text-decoration: none;
  margin-bottom: 20px;
}
.news-link:hover {
  color: #007bff;
}
.news-link2:hover {
  color: #007bff;
}
.news-link3:hover {
  color: #007bff;
}
.news-date3 {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
}
.news-title3 {
  font-size: 23px;
  /* font-weight: bold; */
  margin-bottom: 10px;
  color: #fff;
}
.news-desc3 {
  font-size: 19px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 20px;
  flex: 1;
  /* 设置超出隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: 20px;
}

/* -------------------------------------- */
.section-title h4 {
  font-size: 3.2rem;
  font-weight: 500;
  color: #000;
  margin-bottom: 1rem;
}
.section-description {
  font-size: 1.4rem;
  color: #666;
  line-height: 1.6;
  margin: 0;
  max-width: 100%;
}

/* Products Grid */
.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.product-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.product-card-full {
  grid-column: 1 / -1;
}

.product-image {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.product-image::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30%;
  background: linear-gradient(to top, #ff8a00 0%, transparent 100%);
  pointer-events: none;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.product-content {
  padding: 1.5rem 0;
}

.product-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 1.2rem;
}
.product-title::before {
  content: "|";
  position: absolute;
  left: 0;
  color: #ff8a00;
}

.product-description {
  width: 80%;
  font-size: 1.2rem;
  color: #666;
  line-height: 1.3;
  margin-bottom: 1.5rem;
  text-align: justify;
}

.product-link {
  font-size: 1.3rem;
  color: #ff8a00;
  text-decoration: none;
  transition: color 0.3s ease;
}

.product-link:hover {
  color: #e67e00;
  text-decoration: underline;
}


/* --------------------- */
.banner {
  width: 100%;
  height: 95vh;
  overflow: hidden;
  position: relative;
}
.carousel {
  width: 100%;
  height: 100%;
  position: relative;
}
.carousel-inner {
  display: flex;
  height: 100%;
  transition: transform 0.6s ease;
}
.slide {
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-title {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3.2rem;
  color: #ff8a00;
  letter-spacing: 0.1em;
}
.banner-btn {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.3rem;
  color: #fff;
  padding: 12px 24px;
  cursor: pointer;
  transition: background 0.3s;
}
.btn-icon {
  width: 40px;
  height: 40px;
  background: transparent;
  border: 2px solid #ff8a00;
  border-radius: 50%;
  position: relative;
}
.btn-icon::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-left: 6px solid #ff8a00;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transform: translate(-50%, -50%);
}

.dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}
.dots span {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #38260e;
  cursor: pointer;
  transition: background 0.3s;
}
.dots span.active {
  background: #ff8a00;
}

/* --------------------- */
/* Section 4 - 走进企业 */
.section4 {
  padding: 80px 0;
  background-image: url(/public/imgs/home/images/home-endbg_06.png);
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.about-company {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 60px;
  margin: 0 auto;
}
.company-image {
  flex: 0 0 40%;
  position: relative;
}

.building-img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.company-content {
  flex: 1;
}

.company-title {
  font-size: 3.2rem;
  color: #ff8a00;
  margin-bottom: 5rem;
  font-weight: 500;
  letter-spacing: 0.05em;

}

.company-text {
  margin-bottom: 40px;
}

.company-paragraph {
  font-size: 1.1rem;
  color: #000;
  line-height: 1.8;
  margin-bottom: 1rem;
  text-align: justify;
}

.company-metrics {
  display: flex;
  gap: 6rem;
  padding-top: 30px;
  /* border-top: 1px solid #e0e0e0; */
}

.metric-item {
  display: flex;
  flex-direction: column;
  /* align-items: center;
  text-align: center; */
}

.metric-value {
  font-size: 2.8rem;
  /* font-weight: 700; */
  color: #ff8a00;
  /* margin-bottom: 8px; */
}

.metric-unit {
  font-size: 1.5rem;
  color: #666;
  margin-bottom: 8px;
}

.metric-label {
  font-size: 1rem;
  /* color: #999; */
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* Section 4 Responsive Design */
@media (max-width: 768px) {
  .about-company {
    flex-direction: column;
    gap: 40px;
  }

  .company-image {
    flex: 0 0 100%;
  }

  .company-title {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 2rem;
  }
}
/* ========== 移动端适配 375px 基准 ========== */
@media (max-width: 768px) {
  /* 全局 section 间距缩小 */
  section {
    padding: 2rem 0;
  }
  .banner{
    height: auto;
  }
  /* 轮播标题与按钮 */
  .banner-title {
    font-size: 1.5rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .banner-btn {
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

  /* 产品网格单列 */
  .products-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .product-card {
    flex-direction: column;
  }
  .product-image img {
    height: auto;
  }
  .product-title {
    font-size: 1.1rem;
  }
  .product-description {
    font-size: 0.9rem;
    width: 100%;
  }
  .product-link {
    font-size: 0.9rem;
  }

  /* 合作伙伴区域 */
  .s2-content {
    flex-direction: column;
    height: auto;
  }
  .service-container {
    width: 100%;
    height: auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    overflow-x: auto;
    /* white-space: nowrap; */
    -webkit-overflow-scrolling: touch;
  }
  .service-card {
    flex: 0 0 70%;
    max-width: 260px;
    display: inline-block;
    text-align: center;
    padding: 12px;
    margin: 0 8px;
  }
  .card-img {
    width: 75%;
    height: auto;
    margin-bottom: 12px;
  }
  .card-content {
    padding: 0 12px;
  }
  .card-title {
    font-size: 1.1rem;
  }
  .card-desc {
    font-size: 0.9rem;
    max-width: 100%;
    word-break: break-all;
    overflow-wrap: break-word;
  }

  /* 新闻区三栏→双栏→单列响应式 */
  .news-box {
    flex-direction: row;
    /* flex-wrap: wrap; */
  }
  .news-item,
  .news-item3 {
    flex: 1 1 48%;
    max-width: 48%;
    aspect-ratio: 0.65;
    padding: 1rem;
  }
  .news-item2 {
    flex: 1 1 48%;
    max-width: 48%;
    gap: 1rem;
  }
  .news-s {
    flex: 1 1 100%;
    padding: 1rem;
  }
  .news-item img {
    aspect-ratio: 16 / 9;
  }
  .news-title,
  .news-title3 {
    font-size: clamp(0.9rem, 2vw, 1.1rem);
  }
  .news-desc,
  .news-desc2,
  .news-desc3 {
    font-size: clamp(0.75rem, 1.8vw, 0.9rem);
    -webkit-line-clamp: 3;
    min-height: 0;
  }
  .news-link,
  .news-link2,
  .news-link3 {
    font-size: clamp(0.8rem, 1.9vw, 0.9rem);
  }

  @media (max-width: 600px) {
    .news-item,
    .news-item2,
    .news-item3 {
      flex: 1 1 100%;
      max-width: 100%;
      aspect-ratio: 0.55;
    }
  }

  /* 关于企业区域 */
  .about-company {
    flex-direction: column;
    gap: 1rem;
  }
  .company-image img {
    width: 100%;
    height: auto;
  }
  .company-paragraph {
    font-size: 0.9rem;
  }
  .company-text p{
    font-size: 0.9rem;
  }
  .company-metrics {
    padding: 0;
    gap: 10rem;
  }
  .metric-value {
    font-size: 1.1rem;
  }
  .metric-label {
    font-size: 0.9rem;
  }
}


/* Responsive Design */
@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: 1fr;
  }

  .section-title h4 {
    font-size: 2.4rem;
  }

  .section-description {
    font-size: 1.3rem;
  }

  .product-title {
    font-size: 1.5rem;
  }

  .product-description {
    font-size: 1.2rem;
  }
}

</style>
<style lang="scss">
  .company-text p{
  font-size: 1.1rem;
  color: #000;
  line-height: 1.8;
  margin-bottom: 1rem;
  text-align: justify;
}
@media (max-width: 768px) {
  .company-text p{
    font-size: 0.9rem;
  }
}
</style>